import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-title',
  standalone: true,
  imports: [],
  templateUrl: './dialog-title.component.html',
  styleUrl: './dialog-title.component.scss',
})
export class DialogTitleComponent {}
